import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BigRemoteButton } from "../buttons";
import LightBeam from "../lightBeam/lightBeam";
import { SkitsOlympicLogoIcon } from "../icons";
import { FieldButton } from "../buttons";
import "./universalSearchLauncher.scss"

const UniversalSearchLauncher = ({ initialQuery = "" }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(initialQuery);
  const [isFocused, setIsFocused] = useState(false);
  const [lightBeamOn, setLightBeamOn] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate("/search-accounts", { state: { query } });
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    navigate("/universal-search", { state: { query } });
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const triggerLightBeam = () => {
    setLightBeamOn(true);
    setTimeout(() => setLightBeamOn(false), 500);
  };

  return (
    <form id="searchBar" onSubmit={handleSubmit} className="search-launcher">
      <SkitsOlympicLogoIcon className="search-bar-icon" fillColor="var(--color-gold)" />
      <input
        type="text"
        className="search-input"
        placeholder={isFocused ? "" : "Username/Skit Title?"}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {query && (
        <FieldButton onClick={() => setQuery("")}>Clear</FieldButton>
      )}
      <BigRemoteButton
        onMainClick={() => {
          triggerLightBeam();
          handleSubmit({ preventDefault: () => {} });
        }}
        mainBtnText="Search"
      />
      <LightBeam
        lightBeamStyles={{
          transform: "translateX(2%) translateY(-100%)",
          backgroundColor: lightBeamOn
            ? "var(--color-corveteRed)"
            : "var(--color-redish)",
        }}
      />
    </form>
  );
};

export default UniversalSearchLauncher;